import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {

  currentLang: 'en' | 'ta' = 'en'; // default language

  switchLang(lang: 'en' | 'ta') {
    this.currentLang = lang;
  }
}
